module.exports = __webpack_public_path__ + "static/media/Quarter_B.aa220a6f.png";